/* ====================
    User roles
    =================== */
export const CONTACT_ROLE = 'CONTACT_ROLE';
export const AGENT_ROLE = 'AGENT_ROLE';
export const ADMIN_ROLE = 'ADMIN_ROLE';

/* ====================
    LineId Status
    =================== */
export const LINEID_STATUS = ['APPROVED', 'REFUSED'];

//TODO move to dedicated enum files
